export default {
  no_storefront_found: {
    title: 'Nessuna vetrina trovata',
    description: 'Crea una vetrina.',
  },
};
